import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
      <div class="poem">

        <p class="poem-block mb-3">
          О, Европа!<br/>
          В XV веке ты сжигала своих колдуний на кострах на площадях. Средневековье…
        </p>
        
        <p class="poem-block mb-3">
          В XX веке ты сжигапа своих граждан любого пола и возраста в специальных печах. Прогресс!
        </p>
        
        <p class="poem-block mb-3">
          В XXI веке ты сжигаешь покрышки на кострах на площадях. Деградация.
        </p>
        
        <p class="poem-block mb-3">
          Увы, Европа, Европа!<br/>
          Куда ты катишься так неудержимо, как горящие покрышки? Что ждёт тебя в конце спуска?
        </p>
        
        <p class="poem-block mb-3">
          Нет ответа.
        </p>
      </div>
    `
  )
}

const itemName = {
  rus: 'Песня неевропейского человека XX века'
}

const item = {
  itemlink: getLink(itemName.rus),
  rus:{
    itemName: itemName.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}


export default item;